import './style';

import _Collapse from './Collapse';

export type { CollapseProps } from './Collapse';
export * from './type';

export const Collapse = _Collapse;

export default Collapse;
